import AnimatedShinyText from 'components/magicui/AnimatedShinyText'
import {cn} from 'utils/cn'

/**
 * An inline Sharpenny amount ("+25", "50", "100 Sharpennies") in gold
 * with the Magic UI glare panning across it. Use it wherever a number of
 * coins appears in running text or a ledger row.
 */
const GoldAmount = ({className, children, ...props}) => (
  <AnimatedShinyText
    className={cn(
      'font-bold tabular-nums text-[#b07a1c]/80 via-[#fff4cf]/95',
      className
    )}
    {...props}
  >
    {children}
  </AnimatedShinyText>
)

export default GoldAmount
